<template>
<p class="rating mt-1 d-flex align-items-center">
  <span v-for="index in 5" :key="index">
    <span  class="material-icons"  :class="{ 'text-yellow': index <= rating }">
      star rate
    </span>
  </span>
</p>
</template>

<script>
export default {
  props: {
    rating: {
      type: Number,
      required: true,
    },
  },
};
</script>
